import React from 'react';
import { useInterview } from '../../contexts/InterviewContext';
import { InfoTooltip } from '../../../../components/common/InfoTooltip';

const InterviewDetailsCard: React.FC = () => {
  const { interviewDetails } = useInterview();

  const tooltipMessage = "This shows the maximum duration of the interview, though the interview will last as per the question & answers flow, in most cases lasts shorter than this duration.";

  return (
    <div className="rounded-xl overflow-hidden border border-border-light dark:border-border-dark bg-surface-light/40 dark:bg-surface-dark/40 shadow-sm p-3 sm:p-4">
      <h3 className="font-medium text-base sm:text-lg text-text-primary-light dark:text-text-primary-dark mb-2 sm:mb-3 font-heading">
        Interview Details
      </h3>
      
      <div className="space-y-2 text-xs sm:text-sm">
        {interviewDetails.title && (
          <p className="flex items-center">
            <span className="font-medium inline-block w-20">Title:</span> 
            <span className="text-text-secondary-light dark:text-text-secondary-dark">{interviewDetails.title}</span>
          </p>
        )}
        {interviewDetails.company && (
          <p className="flex items-center">
            <span className="font-medium inline-block w-20">Company:</span> 
            <span className="text-text-secondary-light dark:text-text-secondary-dark">{interviewDetails.company}</span>
          </p>
        )}
        {interviewDetails.jobRole && (
          <p className="flex items-center">
            <span className="font-medium inline-block w-20">Role:</span> 
            <span className="text-text-secondary-light dark:text-text-secondary-dark">{interviewDetails.jobRole.length > 40 ? interviewDetails.jobRole.substring(0,40) + '...': interviewDetails.jobRole}</span>
          </p>
        )}
        {/* Duration display hidden as it can be confusing for users
        {interviewDetails.duration && (
          <p className="flex items-center">
            <span className="font-medium inline-block w-20">Duration:</span> 
            <span className="text-text-secondary-light dark:text-text-secondary-dark">
              <span className="text-text-secondary-light dark:text-text-secondary-dark font-semibold">&lt;</span> {interviewDetails.duration} Minutes
            </span>
            <InfoTooltip 
              message={tooltipMessage}
              size={12}
              className="ml-1"
            />
          </p>
        )} */}
        {interviewDetails.language && (
          <p className="flex items-center">
            <span className="font-medium inline-block w-20">Language:</span> 
            <span className="text-text-secondary-light dark:text-text-secondary-dark">{interviewDetails.languageName || interviewDetails.language}</span>
          </p>
        )}
      </div>
    </div>
  );
};

export default InterviewDetailsCard; 